<template>
    <div class="postavitev-info">
        <div>
            <div class="info-okvir">
                <div class="postavitev-info-icone">
                    <i class="fa fa-info-circle"></i>
                </div>
                <div class="postavitev-info-tekst">
                    <p class="modra-barva-info">
                      Hitrost interneta lahko spremenite enkrat mesečno.
                      Naslednjo spremembo boste lahko izvedli čez {{dniDoMozneSpremembe}} dni.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'InfoKomponentaSamostojneHitrosti',
    props: {
      dniDoMozneSpremembe: 0
    }
  }
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/InfoKomponentaSamostojneHitrosti.css">

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/InfoKomponentaSamostojneHitrosti.vue